$(window).on('load', function(){
  $(document).on('change', '.product-options__item input[type="radio"]', function(){
    if($(this).hasClass('disabled')){
      $('.product-form__low-stock').text('Sold Out');
      $('.product-form__actions .product-form__button').attr('disabled', 'disabled');
      $('.product-form__actions').addClass('productActionbtn_pna');
      $('.product-form__actions .product-form__button .product-form__button-text').text('Sold Out');
    }else{
      $('.product-form__actions').removeClass('productActionbtn_pna');
    }
  });

  $(document).on('click', '.product-form__actions .product-form__button', function(e){
    if($(this).parents('.product-form__actions').hasClass('productActionbtn_pna')){
      e.preventDefault();
    }
  });
});



/* window.addEventListener('load', function() {
  document.addEventListener('change', function(e) {
    if (e.target.matches('.product-options__item input[type="radio"]')) {
      if (e.target.classList.contains('disabled')) {
        document.querySelector('.product-form__low-stock').textContent = 'Sold Out';
        document.querySelector('.product-form__actions .product-form__button').setAttribute('disabled', 'disabled');
        document.querySelector('.product-form__actions').classList.add('productActionbtn_pna');
        document.querySelector('.product-form__actions .product-form__button .product-form__button-text').textContent = 'Sold Out';
      } else {
        document.querySelector('.product-form__actions').classList.remove('productActionbtn_pna');
      }
    }
  });

  document.addEventListener('click', function(e) {
    if (e.target.matches('.product-form__actions .product-form__button')) {
      if (e.target.closest('.product-form__actions').classList.contains('productActionbtn_pna')) {
        e.preventDefault();
      }
    }
  });
}); */
